var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTable = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 3h2.5v2.5H3zm7.5 0H13v2.5h-2.5zM9.25 3h-2.5v2.5h2.5zM3 6.75h2.5v2.5H3zm10 0h-2.5v2.5H13zm-6.25 0h2.5v2.5h-2.5zM5.5 10.5H3V13h2.5zm5 0H13V13h-2.5zm-1.25 0h-2.5V13h2.5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTable);
export default ForwardRef;